abstract class CheckboxGroup extends Widget {
    protected constructor(identifier: string, controller: Controller, mode: string) {
        super(identifier, Action.NONE, controller, null, mode);
    }

    newState() {
        return new CheckboxGroupState();
    }

    setState(newCheckboxGroupState) {
        for(let checkbox in this.children) {
            this.children[checkbox].setState(newCheckboxGroupState.getCheckboxState(checkbox));
        }
    }

    getState() {
        var result = new CheckboxGroupState();

        for(let checkbox in this.children) {
            result.setCheckboxState(checkbox, this.children[checkbox].getState());
        }

        return result;
    }

    previewState(newCheckboxGroupState, timeRatioLeft) {
        for(let checkbox in this.children) {
            this.children[checkbox].previewState(newCheckboxGroupState.getCheckboxState(checkbox), timeRatioLeft);
        }
    }

    removePreviewState() {
        for(let checkbox in this.children) {
            this.children[checkbox].removePreviewState();
        }
    }
}
